<template>
    <a
        v-if="labelToken !== 'categories' && labelToken !== 'offers'"
        :class="{
            'l-ss-c-completions-item-is-active': isActive,
            'l-ss-c-completions-item-is-current': (data.active === 1),
            [`l-ss-c-completions-item-type-${labelToken}`]: Boolean(labelToken)
        }"
        :href="data.url"
        :target="$configuration.linkTargetBlank ? '_blank': '_self'"
        class="l-ss-c-completions-item">
        <div
            class="l-ss-c-completions-item-icon-wrapper"
            v-if="$screen.isMobile">
            <i
                class="l-ss-c-completions-item-icon"
                v-html="completionIcons[data.label]"></i>
        </div>
        <span
            class="l-ss-c-completions-item-title"
            v-html="textLabel || textValue"></span>
        <i
            v-if="data.label === 'history'"
            class="l-ss-c-completions-item-icon-remove"
            v-html="iconDeleteQuery"
            @click.stop="removeUserHint(data)"></i>
        <div
            v-if="data.label === 'special_offers'"
            class="l-ss-c-completions-item-promo-label">
            {{ $t('completions.category.special_offers') }}
        </div>
    </a>
    <completions-item-category
        v-else-if="labelToken === 'categories'"
        :is-active="isActive"
        :data="data"
        :text-label="textLabel"/>
</template>

<script>
    import searchIcon from '@/core/assets/images/icons/search-icon.svg';
    import clockIcon from '@/core/assets/images/icons/clock-icon.svg';
    import specialOffersIcon from '@/core/assets/images/icons/special-offers-icon.svg';
    import iconDeleteQuery from '../../../core/assets/images/icons/delete-query.svg';

    import CompletionsItemCategory from '@/core/components/completions/completions-item-category.vue';

    export default {
        components: {
            CompletionsItemCategory,
        },
        props: {
            isActive: {
                type: Boolean,
                required: false,
                default: false,
            },
            isCartAvailable: {
                type: Boolean,
                default: false,
            },
            isCatPrefixActive: {
                type: Boolean,
                default: true,
            },
            data: { // Backend response completions item
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                isActiveImageError: false,
                isActiveImageLoaded: false,
                errorCustomImg: false,
                isShowSnippetTooltip: false,
                isActiveSnippetTooltip: false,
                completionIcons: {
                    suggestions: searchIcon,
                    popular: searchIcon,
                    history: clockIcon,
                    special_offers: specialOffersIcon,
                },
            };
        },
        computed: {
            iconDeleteQuery() {
                return iconDeleteQuery;
            },
            textLabel() {
                return this.data.text.html || this.data.text.label || '';
            },
            textValue() {
                return this.data.text.value || this.data.text.label || '';
            },
            labelToken() {
                return this.data.label;
            },
        },
        created() {
            if (this.$configuration.errorImg) {
                const errorImg = document.createElement('img');
                errorImg.src = this.$configuration.errorImg;
                errorImg.onload = () => {
                    this.errorCustomImg = this.$configuration.errorImg;
                };
                errorImg.onerror = () => {
                    this.errorCustomImg = false;
                };
            }
        },
        methods: {
            removeUserHint(data) {
                this.$emit('remove-history', data);
            },
        },
    };
</script>
